// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.integrationFinishPage {
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #D1D5DB;
    border-radius: 10px;
    font-size: 15px;
}

.finishPageContent {
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 20px;
    overflow: auto;
}


.statusCard {
    height: 52px;
    width: 100%;
    background-color: #97bf0d;
    border-radius: 6px;
}

.statusCardContent {
    justify-content: flex-start; 
    align-items: center;
    margin-left: 4px;
}

.statusCardText {
    align-items: center;
    justify-content: center;
    font: normal normal 600 15px/20px Segoe UI;
    opacity: 1;
}

.successIcon {
    display: flex;
    justify-content: flex-start;
    height: 36px;
    width: 36px;
}

.previewBtn {
    background: var(--integration-background);
    border-radius: 6px;
    height: 40px;
    width: 140px;
    border: 2px solid var(--integration-background);
    color: var(--integration-text-color);
    transition: all 0.3s;
    cursor: pointer;
    box-shadow: 0 4px 6px -4px rgba(0, 0, 0,.7);
    font: normal normal 600 15px/20px Segoe UI;
    letter-spacing: 0.5px;
}

    .previewBtn:hover {
        background-color: var(--integration-hover-background);
        border-color: var(--integration-hover-background);
    }

.previewBtnText {
    margin-left: 4px;
}

.previewIcon {
    color: var(--integration-text-color);
}

.executeBtn {
    background: var(--integration-background);
    margin-left: 22px;
    border-radius: 6px;
    height: 40px;
    width: 140px;
    border: 2px solid var(--integration-background);
    color: var(--integration-text-color);
    transition: all 0.3s;
    cursor: pointer;
    box-shadow: 0 4px 6px -4px rgba(0, 0, 0,.7);
    font: normal normal 600 15px/20px Segoe UI;
    letter-spacing: 0.5px;
}

    .previewBtn:hover {
        background-color: var(--integration-hover-background);
        border-color: var(--integration-hover-background);
    }

.previewBtnText {
    margin-left: 4px;
}

.previewIcon {
    color: var(--integration-text-color);
}

.resultTable {
    justify-content: flex-start;
    margin-top: 20px;
    margin-bottom: 6px;
}

.resultTableRow {
    /*height: 55px;*/
    min-height: 55px;
    overflow: hidden;
    border-top: solid 1px lightgray;
    justify-content: flex-start;
    align-items: center;
    width: 1000px;
}
.resultTableHeader {
    justify-content: flex-start;
    width: 400px;
    font: normal normal 600 15px/20px Segoe UI;
    color: #606060;
   
}

.resultTableContent {
    justify-content: flex-start;
    width: 400px;
    font: normal normal 500 15px/20px Segoe UI;
    color: #454545
}

.resultTableShowMappedCols {
    justify-content: flex-end;
}

.resultHeader {
    font: normal 600 normal 22px/25px Segoe UI;
    letter-spacing: 1px;
    color: #0F3443;
    opacity: 1;
}

.resultSubHeader {
    font: normal 600 normal 17px/20px Segoe UI;
    margin-top: 6px;
    color: var(--integration-light-text-color);
    opacity: 1;
}

.showMappedColumns {
    justify-content: flex-end;
    width: 400px;
    font: normal normal 500 15px/20px Segoe UI;
    color: var(--integration-background)
}

.mappedColumnsHeader {
    font: normal 600 normal 20px/20px Segoe UI;
    margin-bottom: 4px;
    color: var(--integration-text-color);
    opacity: 1;
}

.mappedColumnsTable {
    justify-content: flex-start;
    margin-top: 10px;
    margin-bottom: 10px;
}

.mappedColumnsTableHeader {
    height: 20px;
    justify-content: flex-start;
    font: normal normal 600 17px/20px Segoe UI;
    color: #454545;
    align-items: center;
    width: 400px;
}

.mappedColumnsTableContent {
    justify-content: flex-start;
    border-top: solid 1px lightgray;
    width: 400px;
    font: normal normal 500 15px/20px Segoe UI;
    color: #606060;
}

.useBulkHeader {
    font: normal normal 600 15px/20px Segoe UI;
    opacity: 1;
    color: #374151;
    margin-top: 2px;
    margin-bottom: 4px;
}


.useBulkSubHeader {
    margin-top: 2px;
    font: normal normal 600 15px/20px Segoe UI;
    color: var(--integration-light-text-color);
    opacity: 1;
}

.useBulkRadioBtn {
    margin-top: 8px;
    margin-left: 10px;
    margin-bottom: 10px;
    color: var(--integration-color);
}

.succesfulImportCard {
    display: flex;
    width: 100%;
    height: 50px;
    background: var(--integration-background);
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.succesfulImportCardText {
    font: normal normal 500 15px/20px Segoe UI;
    color: var(--integration-text-color);

}

.unsuccesfulImportCard {
    display: flex;
    width: 100%;
    height: 50px;
    background: #ff4c4c;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.unsuccesfulImportCardText {
    font: normal normal 500 15px/20px Segoe UI;
    color: #a6241c;
}`, "",{"version":3,"sources":["webpack://./src/app/integration/integrationwizard/iw.finish.page.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;IACjC,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;;AAGA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;IAC1C,UAAU;AACd;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,yCAAyC;IACzC,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,+CAA+C;IAC/C,oCAAoC;IACpC,oBAAoB;IACpB,eAAe;IACf,2CAA2C;IAC3C,0CAA0C;IAC1C,qBAAqB;AACzB;;IAEI;QACI,qDAAqD;QACrD,iDAAiD;IACrD;;AAEJ;IACI,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yCAAyC;IACzC,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,+CAA+C;IAC/C,oCAAoC;IACpC,oBAAoB;IACpB,eAAe;IACf,2CAA2C;IAC3C,0CAA0C;IAC1C,qBAAqB;AACzB;;IAEI;QACI,qDAAqD;QACrD,iDAAiD;IACrD;;AAEJ;IACI,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,+BAA+B;IAC/B,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,2BAA2B;IAC3B,YAAY;IACZ,0CAA0C;IAC1C,cAAc;;AAElB;;AAEA;IACI,2BAA2B;IAC3B,YAAY;IACZ,0CAA0C;IAC1C;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0CAA0C;IAC1C,mBAAmB;IACnB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,0CAA0C;IAC1C,eAAe;IACf,0CAA0C;IAC1C,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,0CAA0C;IAC1C;AACJ;;AAEA;IACI,0CAA0C;IAC1C,kBAAkB;IAClB,oCAAoC;IACpC,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,2BAA2B;IAC3B,0CAA0C;IAC1C,cAAc;IACd,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,+BAA+B;IAC/B,YAAY;IACZ,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,0CAA0C;IAC1C,UAAU;IACV,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;;AAGA;IACI,eAAe;IACf,0CAA0C;IAC1C,0CAA0C;IAC1C,UAAU;AACd;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,4EAA4E;AAChF;;AAEA;IACI,0CAA0C;IAC1C,oCAAoC;;AAExC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,4EAA4E;AAChF;;AAEA;IACI,0CAA0C;IAC1C,cAAc;AAClB","sourcesContent":[".integrationFinishPage {\n    box-shadow: 0px 3px 6px #00000029;\n    border: 1px solid #D1D5DB;\n    border-radius: 10px;\n    font-size: 15px;\n}\n\n.finishPageContent {\n    margin-left: 20px;\n    margin-right: 20px;\n    margin-top: 20px;\n    overflow: auto;\n}\n\n\n.statusCard {\n    height: 52px;\n    width: 100%;\n    background-color: #97bf0d;\n    border-radius: 6px;\n}\n\n.statusCardContent {\n    justify-content: flex-start; \n    align-items: center;\n    margin-left: 4px;\n}\n\n.statusCardText {\n    align-items: center;\n    justify-content: center;\n    font: normal normal 600 15px/20px Segoe UI;\n    opacity: 1;\n}\n\n.successIcon {\n    display: flex;\n    justify-content: flex-start;\n    height: 36px;\n    width: 36px;\n}\n\n.previewBtn {\n    background: var(--integration-background);\n    border-radius: 6px;\n    height: 40px;\n    width: 140px;\n    border: 2px solid var(--integration-background);\n    color: var(--integration-text-color);\n    transition: all 0.3s;\n    cursor: pointer;\n    box-shadow: 0 4px 6px -4px rgba(0, 0, 0,.7);\n    font: normal normal 600 15px/20px Segoe UI;\n    letter-spacing: 0.5px;\n}\n\n    .previewBtn:hover {\n        background-color: var(--integration-hover-background);\n        border-color: var(--integration-hover-background);\n    }\n\n.previewBtnText {\n    margin-left: 4px;\n}\n\n.previewIcon {\n    color: var(--integration-text-color);\n}\n\n.executeBtn {\n    background: var(--integration-background);\n    margin-left: 22px;\n    border-radius: 6px;\n    height: 40px;\n    width: 140px;\n    border: 2px solid var(--integration-background);\n    color: var(--integration-text-color);\n    transition: all 0.3s;\n    cursor: pointer;\n    box-shadow: 0 4px 6px -4px rgba(0, 0, 0,.7);\n    font: normal normal 600 15px/20px Segoe UI;\n    letter-spacing: 0.5px;\n}\n\n    .previewBtn:hover {\n        background-color: var(--integration-hover-background);\n        border-color: var(--integration-hover-background);\n    }\n\n.previewBtnText {\n    margin-left: 4px;\n}\n\n.previewIcon {\n    color: var(--integration-text-color);\n}\n\n.resultTable {\n    justify-content: flex-start;\n    margin-top: 20px;\n    margin-bottom: 6px;\n}\n\n.resultTableRow {\n    /*height: 55px;*/\n    min-height: 55px;\n    overflow: hidden;\n    border-top: solid 1px lightgray;\n    justify-content: flex-start;\n    align-items: center;\n    width: 1000px;\n}\n.resultTableHeader {\n    justify-content: flex-start;\n    width: 400px;\n    font: normal normal 600 15px/20px Segoe UI;\n    color: #606060;\n   \n}\n\n.resultTableContent {\n    justify-content: flex-start;\n    width: 400px;\n    font: normal normal 500 15px/20px Segoe UI;\n    color: #454545\n}\n\n.resultTableShowMappedCols {\n    justify-content: flex-end;\n}\n\n.resultHeader {\n    font: normal 600 normal 22px/25px Segoe UI;\n    letter-spacing: 1px;\n    color: #0F3443;\n    opacity: 1;\n}\n\n.resultSubHeader {\n    font: normal 600 normal 17px/20px Segoe UI;\n    margin-top: 6px;\n    color: var(--integration-light-text-color);\n    opacity: 1;\n}\n\n.showMappedColumns {\n    justify-content: flex-end;\n    width: 400px;\n    font: normal normal 500 15px/20px Segoe UI;\n    color: var(--integration-background)\n}\n\n.mappedColumnsHeader {\n    font: normal 600 normal 20px/20px Segoe UI;\n    margin-bottom: 4px;\n    color: var(--integration-text-color);\n    opacity: 1;\n}\n\n.mappedColumnsTable {\n    justify-content: flex-start;\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n.mappedColumnsTableHeader {\n    height: 20px;\n    justify-content: flex-start;\n    font: normal normal 600 17px/20px Segoe UI;\n    color: #454545;\n    align-items: center;\n    width: 400px;\n}\n\n.mappedColumnsTableContent {\n    justify-content: flex-start;\n    border-top: solid 1px lightgray;\n    width: 400px;\n    font: normal normal 500 15px/20px Segoe UI;\n    color: #606060;\n}\n\n.useBulkHeader {\n    font: normal normal 600 15px/20px Segoe UI;\n    opacity: 1;\n    color: #374151;\n    margin-top: 2px;\n    margin-bottom: 4px;\n}\n\n\n.useBulkSubHeader {\n    margin-top: 2px;\n    font: normal normal 600 15px/20px Segoe UI;\n    color: var(--integration-light-text-color);\n    opacity: 1;\n}\n\n.useBulkRadioBtn {\n    margin-top: 8px;\n    margin-left: 10px;\n    margin-bottom: 10px;\n    color: var(--integration-color);\n}\n\n.succesfulImportCard {\n    display: flex;\n    width: 100%;\n    height: 50px;\n    background: var(--integration-background);\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n\n.succesfulImportCardText {\n    font: normal normal 500 15px/20px Segoe UI;\n    color: var(--integration-text-color);\n\n}\n\n.unsuccesfulImportCard {\n    display: flex;\n    width: 100%;\n    height: 50px;\n    background: #ff4c4c;\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n\n.unsuccesfulImportCardText {\n    font: normal normal 500 15px/20px Segoe UI;\n    color: #a6241c;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
